<template>
  <div class="search-listing-page-wrapper">
    <div v-if="displaySections?.length" class="dynamic-section">
      <PageSection v-for="(section, index) in displaySections" :key="`${index}-section`" :section="section" />
    </div>
    <client-only>
      <section class="plp-main">
        <div
          v-if="getEnabledSort || getEnabledFilter"
          :class="['filter-section', { open: state.mobileFilterDropdown }]"
        >
          <div class="mobile-filter-header">
            <span class="mobile-filter-title">Filter</span>
            <CustomButton class="close-filter" style-name="tertiary" @click-button="handleFilterDropdown">
              <CloseLine class="close-svg" />
            </CustomButton>
          </div>
          <Accordion
            v-if="getEnabledSort"
            :key="`${state.sortClear}-price-sort`"
            class="filter-accordion"
            title="Sort By"
            desc="."
            :click-stop="true"
            :default-open="true"
            emit-open="open"
            @open="(e: any) => accordionStatus(e, 'sortAccordionStatus')"
          >
            <template #content>
              <Radios
                class="filter-options"
                option-set-name="Sort by Price"
                :radio-options="getIndexSorters()"
                emit-radio-changed="sort-change"
                @sort-change="sortChange"
              />
            </template>
          </Accordion>
          <Accordion
            v-if="getEnabledFilter"
            :key="keyBuster"
            class="filter-accordion"
            title="Price"
            desc="."
            :click-stop="true"
            :default-open="true"
            emit-open="open"
            @open="(e: any) => accordionStatus(e, 'priceAccordionStatus')"
          >
            <template #content>
              <Checkboxes
                class="filter-options"
                :inverse-checkbox-options="priceFilterOptions()"
                :checkbox-options="[]"
                option-set-name="Filter by Price Range"
                emit-checkbox-changed="filterChange"
                @filter-change="handleFilterChange"
              />
            </template>
          </Accordion>
          <div v-if="getEnabledFilter || getEnabledSort" class="mobile-filter-buttons">
            <CustomButton style-color="black" style-name="secondary" @click-button="clearFilters">Clear</CustomButton>
            <CustomButton style-color="black" style-name="primary" @click-button="handleFilterDropdown"
              >Apply</CustomButton
            >
          </div>
        </div>
        <div class="products-display">
          <AisInstantSearch
            :index-name="aisIndexName"
            :search-client="searchClient"
            :search-function="searchFunction"
            :middlewares="state.middlewares"
            :insights="true"
            @view="
              () => {
                sendEvent('view', items, 'View Products');
              }
            "
          >
            <AisStateResults>
              <!-- eslint-disable-next-line vue/no-unused-vars -->
              <template #default="{ results: { hits, query } }">
                <!-- TODO: Find better way to do this -->
                <!-- <Emitter
                v-if="renderMode !== 'plp'"
                :data-receiver="hits"
                emit-data="emitData"
                @emitData="(e) => bounceRec(e)"
              /> -->
                <!-- <h1 v-if="initialResults && !bounceStop" class="results-page-title"> -->
                <h1 class="results-page-title">
                  {{ (plpTitle && plpTitle) || (query && `${useTranslate('Search.search')} Results "${query}"`) }}
                </h1>
                <div v-if="state.bounceStop">
                  <h1 class="results-page-title">Sorry, no results for "{{ state.oldQuery }}" were found.</h1>
                  <h2 class="results-page-title">Explore Best-Selling Products</h2>
                </div>
              </template>
            </AisStateResults>
            <!-- eslint-disable vue/attribute-hyphenation -->
            <!-- Do not make this hyphenated. AIS is set in its ways. -->
            <AisConfigure
              :filters="filterBy"
              :hitsPerPage="1000"
              :click-analytics.camel="true"
              :user-token.camel="state.userToken"
            />
            <!-- eslint-enable vue/attribute-hyphenation -->
            <!-- <ais-refinement-list attribute="categories" /> -->
            <AisSearchBox style="display: none" :value="state.queryString" />

            <!-- <AisSortBy
            :items="[]"
          > -->
            <!-- <template #default="{ items, currentRefinement, refine }"> -->
            <!-- TODO: Find better way to do this -->
            <!-- <template #default="{ refine }">
              <Emitter
                :data-receiver="sortValue"
                emit-data="emitData"
                @emitData="(e) => sortIndexChange(e, refine)"
              />
            </template> -->
            <!-- </AisSortBy> -->
            <AisStats>
              <template #default="{ nbHits }">
                <span v-if="!state.bounceStop">{{ nbHits }} Result{{ nbHits === 1 ? '' : 's' }}</span>

                <section v-if="getEnabledFilter || getEnabledSort" class="mobile-filter-section">
                  <CustomButton
                    class="mobile-filter-btn"
                    :is-small="true"
                    style-color="black"
                    style-name="secondary"
                    :aria-attrs="{
                      ariaExpanded: state.mobileFilterDropdown,
                    }"
                    @click-button="handleFilterDropdown"
                  >
                    Filter
                    <template #secondaryIcon>
                      <Filter3Line />
                    </template>
                  </CustomButton>
                </section>
              </template>
            </AisStats>
            <section v-if="getEnabledFilter || getEnabledSort" class="filter-clearing filter-chips">
              <CustomButton
                v-if="state.filterTracker?.length"
                class="clear-all-btn"
                style-name="tertiary"
                style-color="black"
                @click-button="clearFilters"
              >
                Clear All
              </CustomButton>
              <!-- <div class="filter-chips"> -->
              <Chip
                v-if="state.sortValue !== 'Relevance'"
                :key="`sortChip-${state.sortValue}`"
                :text="state.sortValue"
                :aria-label="`Remove sort method ${state.sortValue}`"
                theme="neutralgrey"
                @click-button="unsort"
              />
              <Chip
                v-for="filterString in state.filterTracker"
                :key="filterString"
                :text="filterString"
                :aria-label="`Remove filter ${filterString}`"
                theme="neutralgrey"
                @click-button="spliceFilter"
              />
              <!-- </div> -->
            </section>
            <AisHits>
              <template #default="{ items, sendEvent }">
                <ol class="ais-Hits-list" :cordial="trackSearch(items)">
                  <li
                    v-for="(item, i) in items"
                    :key="`plp-item-${i}-${item.objectID}`"
                    :data-insights-object-id="item.objectID"
                    :data-insights-position="item.__position"
                    :data-insights-query-id="item.__queryID"
                    class="ais-Hits-item"
                    @click="
                      () => {
                        sendEvent('click', item, 'Click Product');
                        trackClick(items.length, item, i);
                      }
                    "
                  >
                    <ProductCard
                      :product="useBcAlgoliaData(item, locale)"
                      :render-mode="renderMode"
                      :show_add_to_cart="getAlgoliaATCEnabled || show_add_to_cart"
                      :query-i-d="item.__queryID"
                      :index="i"
                      :is-dynamic-section="true"
                      emit-added="added"
                      @added="sendEvent('conversion', useBcAlgoliaData(item, locale), 'Add to Cart')"
                    />
                  </li>
                </ol>
              </template>
            </AisHits>
          </AisInstantSearch>
        </div>
      </section>
      <template #placeholder>
        <div class="loading-container">
          <div class="filter-section">
            <div class="skeleton skeleton-section" style="height: 55px" />
            <div class="skeleton skeleton-section" style="height: 45px" />
          </div>

          <div class="flex-wrap items-container">
            <div class="skeleton skeleton-text desk-only" style="height: 55px" />
            <div class="skeleton skeleton-text desk-only" style="height: 45px" />
            <div v-for="(item, idx) in 12" :key="idx + 'container'" class="flex-col loading-item">
              <div class="skeleton skeleton-section img" />
              <div class="skeleton skeleton-text" style="width: 60%" />
              <div class="skeleton skeleton-text" style="width: 30%" />
              <div class="skeleton skeleton-text" style="width: 25%" />
            </div>
          </div>
        </div>
      </template>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import {
  AisInstantSearch,
  AisConfigure,
  // AisRefinementList,
  AisHits,
  // AisHighlight,
  AisSearchBox,
  // AisSortBy,
  AisStats,
  AisStateResults,
  // AisPagination,
} from 'vue-instantsearch/vue3/es/index';
import { getCookie } from '../util/storage';
import { CheckboxesReturn } from '~/components/Checkboxes.vue';
import { ChangePayload as RadioChangePayload } from '~/types/solo-input';
import { useLocaleStore } from '~/store/locale';
import { useRootStore } from '~/store';
import { parseFilter, getAisIndex, getVariantSkuFromBase } from '~/util/algolia';
// import { GtmEventType, mapAlgoliaSearchToGtmEvent, baseEcommerceEventStructure } from '~/util/analytics';
import {
  mapAlgoliaSearchClickToGtmEvent,
  mapAlgoliaSearchResultsToGtmEvent,
  GtmEventType,
  extractGoogleAnalyticsUserIdFromCookie,
} from '~/util/analytics';
import { useProductDataStore } from '~/store/product-data';
const productDataStore = useProductDataStore();
type PriceFilterOptionRaw = {
  value: number[];
  override: boolean;
  overrideValue?: boolean | undefined;
};

type IndexSort = {
  value: string;
  label: string;
};

type RangeOption = {
  end_number: number;
  group_title?: string;
  start_number: number;
};

const { locale } = useI18n();
const route = useRoute();
const rootStore = useRootStore();
const localeStore = useLocaleStore();

const props = defineProps({
  plp: {
    type: Object as () => any,
    default: () => {},
  },
  searchPage: {
    type: Object as () => any,
    default: () => {},
  },
  pageQuery: {
    type: String,
    default: '',
  },
  filterByStarter: {
    type: String,
    default: '',
  },
  renderMode: {
    type: String,
    default: 'search',
  },
  // eslint-disable-next-line vue/prop-name-casing
  show_add_to_cart: {
    type: Boolean,
    default: false,
  },
});

const state = reactive({
  bounceStop: false,
  extraFilter: '',
  mobileFilterDropdown: false,
  priceFilterOptionsRaw: [] as any[],
  keyTrack: 0,
  priceAccordionStatus: false,
  sortAccordionStatus: false,
  filterTracker: [] as string[],
  initialResults: props.renderMode === 'plp',
  oldQuery: '',
  queryString: props?.pageQuery || route?.query?.q,
  sortValue: 'Relevance',
  sortClear: false,
  timerId: null as any,
  userToken: '',
});

const algoliaSettingsStore = computed(() => rootStore.algoliaSettings);
const aisIndexName = computed(() => getAisIndex());
const searchClient = useAlgoliaRef();
const indexSorts = computed(() => {
  return [
    { value: `${aisIndexName.value}`, label: 'Relevance' },
    { value: `${aisIndexName.value}_price_desc`, label: 'Price: High-Low' },
    { value: `${aisIndexName.value}_price_asc`, label: 'Price: Low-High' },
  ];
});
const currencySymbol = computed(() => localeStore.currencySymbol);
const currencyCode = computed(() => localeStore.currencyCode);
const displaySections = computed<any[]>(() => props.plp?.sections || []);
const filterBy = computed<string>(() => {
  const starter = props.filterByStarter || '';
  return starter + state.extraFilter;
});
const algoliaSettings = computed(() => {
  const plpSettings = props.plp?.algolia_settingsConnection?.edges?.[0]?.node;
  const searchPageSettings = props.searchPage?.searchSettingsData;
  return plpSettings || searchPageSettings || algoliaSettingsStore.value;
});
const getEnabledFilter = computed(() => algoliaSettings.value?.price_filter?.enabled || false);
const getEnabledSort = computed(() => algoliaSettings.value?.price_sorting?.enabled || false);
const getAlgoliaATCEnabled = computed(() => algoliaSettings.value?.add_to_cart || false);
const getRawFilters = computed<PriceFilterOptionRaw[]>(() => {
  const rawOptions = algoliaSettings.value?.price_filter || {
    enabled: true,
    price_range: [
      {
        end_number: 100,
        start_number: 0,
      },
      {
        end_number: 250,
        start_number: 100,
      },
      {
        end_number: 400,
        start_number: 250,
      },
      {
        end_number: 550,
        start_number: 400,
      },
    ] as RangeOption[],
  };
  return (
    (rawOptions.enabled &&
      rawOptions.price_range.map((rangeOption: RangeOption) => {
        return {
          value: [rangeOption.start_number, rangeOption.end_number],
          override: false,
        };
      })) ||
    ([] as PriceFilterOptionRaw[])
  );
});
const keyBuster = computed(() => state.keyTrack + '-price-filtering');
const plpTitle = computed<string>(() => props.plp?.display_title || props.plp?.title || '');

watch(
  () => route.query,
  (newQuery) => {
    state.queryString = (newQuery?.q as string) || '';
    state.bounceStop = false;
    state.oldQuery = '';
    state.initialResults = false;
    clearFilters();
  }
);

onBeforeMount(() => {
  // TODO - view_item_list event
  state.priceFilterOptionsRaw = getRawFilters.value;
  const _ga = getCookie('_ga');
  state.userToken = extractGoogleAnalyticsUserIdFromCookie(_ga) || '';
});
onUnmounted(() => {
  if (state.timerId) clearTimeout(state.timerId);
});

function accordionStatus(e: boolean, setStatus: 'priceAccordionStatus' | 'sortAccordionStatus') {
  state[setStatus] = e;
}
// function bounceRec(e: any) {
//   if (e && e.length > 0) {
//     state.initialResults = true;
//   }
//   if (!state.bounceStop && !state.initialResults) {
//     state.oldQuery = state.queryString as string;
//     state.queryString = '';
//     state.bounceStop = true;
//   }
// }
function clearFilters() {
  state.keyTrack++;
  if (state.keyTrack > 15) state.keyTrack = 0;
  state.priceFilterOptionsRaw.forEach((option: PriceFilterOptionRaw) => {
    option.override = true;
    option.overrideValue = false;
  });
  state.extraFilter = '';
  state.filterTracker = [] as string[];
  state.sortValue = getIndexSorters()[0];
  state.sortClear = !state.sortClear;
}
// function getIndexFromSorter(value: string): number {
//   return getIndexSorters()?.indexOf(value);
// }
function getIndexSorters(): string[] {
  return indexSorts.value.length ? indexSorts.value.map((sortIndex: IndexSort) => sortIndex.label) : ([] as string[]);
}
function handleFilterChange(e: CheckboxesReturn) {
  state.filterTracker = e?.allChecked || ([] as string[]);
  state.extraFilter = parseFilter(state.filterTracker, props.filterByStarter, currencyCode.value);
}
function handleFilterDropdown() {
  state.mobileFilterDropdown = !state.mobileFilterDropdown;
  if (state.mobileFilterDropdown) {
    document.body.classList.add('scroll-stop-mobile');
  } else {
    document.body.classList.remove('scroll-stop-mobile');
  }
}
function priceFilterOptions() {
  return state.priceFilterOptionsRaw.map((option: PriceFilterOptionRaw) => {
    return {
      value: `${currencySymbol.value}${option.value[0]} - ${currencySymbol.value}${option.value[1]}`,
      override: option.override,
      overrideValue: option.overrideValue,
    };
  });
}
function searchFunction(helper: any) {
  /*
    TODO: Find out why there's dupe calls
    on search landing page on first land.
    It may have something to do with default functionality
    for instantsearch to execute an empty search no matter what.
    Solution will have to be compatible with PLP calls.

    Not as big as PLPs. This should fix PLP duped calls.

  */
  if (state.timerId) clearTimeout(state.timerId);
  state.timerId = setTimeout(() => {
    helper?.search();
  }, 75);
}

let savedProductList = '';
function trackSearch(productsList: any) {
  if (JSON.stringify(productsList) !== JSON.stringify(savedProductList) && savedProductList !== '') {
    const productIdList = [] as string[];
    productsList.forEach((product) => productIdList.push(product.product_offerings?.bc_primary_product?.product?.sku));

    const gtm = useGtm();
    gtm?.trackEvent(mapAlgoliaSearchResultsToGtmEvent(GtmEventType.search, state.queryString as string, productIdList));
  }
  savedProductList = productsList;
}
function sortChange(e: RadioChangePayload) {
  state.sortValue = e.value;
}
// function sortIndexChange(e: any, refine: any) {
//   const index = indexSorts.value[getIndexFromSorter(e)];
//   index?.value && refine(index.value);
// }
function spliceFilter(filter: string) {
  if (state.filterTracker.includes(filter)) {
    state.filterTracker.splice(state.filterTracker.indexOf(filter), 1);
    state.extraFilter = parseFilter(state.filterTracker, props.filterByStarter, currencyCode.value);
    const trackersArr = state.filterTracker.map((trackedFilter: string) =>
      trackedFilter.match(/[ 0-9A-Za-z-]/g)?.join('')
    );
    state.priceFilterOptionsRaw.forEach((filterOption: PriceFilterOptionRaw) => {
      const value = filterOption.value;
      if (trackersArr.includes(value.join(' - '))) {
        filterOption.override = true;
        filterOption.overrideValue = true;
      } else {
        filterOption.override = true;
        filterOption.overrideValue = false;
      }
    });
    state.keyTrack++;
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function trackClick(numItems: number, productData: any, i?: number) {
  /* eslint-disable camelcase */
  const { bcId, sku, url, sell_price, msrp, __position } = productData;
  let dataPayload = {} as any;
  if (plpTitle.value) {
    dataPayload.PageType = 'PLP'; // previously in heap
  } else {
    dataPayload.PageType = 'Search Page'; // previously in heap
  }
  const skuToPull = getVariantSkuFromBase(productData, state) || sku;
  const sellPrice = productDataStore.getPriceBySku(skuToPull)?.calculated_price;
  // TODO - Convert data after webhook change
  // const categoryPass = categories?.length && categories.join(', ');
  const priceSortPass = state.extraFilter
    .replace(/( AND |sell_price.*?:)/g, '')
    .replace(/ TO /g, '-')
    .replace(/ OR /g, ', ');
  dataPayload = {
    ...dataPayload,
    ...(bcId && { productId: bcId }),
    productSKU: sku || productData.product_offerings.bc_primary_product.product.sku,
    productURL: url,
    finalPrice: sellPrice || sell_price,
    originalPrice: msrp,
    positionOfTile: __position,
    priceFilter: priceSortPass,
    priceSort: state.sortValue, // TODO - parse string when extra filtering is added
    totalTiles: numItems,
  };
  const gtm = useGtm();
  gtm?.trackEvent(mapAlgoliaSearchClickToGtmEvent(GtmEventType.searchClickItem, dataPayload as any));
}
function unsort() {
  state.sortValue = indexSorts.value?.[0]?.label;
  state.sortClear = !state.sortClear;
}
</script>

<style lang="scss" scoped>
@mixin filterFlyout {
  background: $color-neutral-white;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 3;

  &.open {
    display: initial;
    padding: 1rem;
  }
}

.dynamic-section {
  padding-bottom: 1rem;

  @include local-mixins.desktop {
    padding-bottom: 1.5rem;
  }
}

.plp-main {
  @include local-mixins.desktop {
    display: flex;
    gap: 2rem;
    justify-content: center;
  }

  @include local-mixins.tablet_and_mobile {
    padding: 0 #{local-functions.rem-calc(27)};
  }
}

.filter-section {
  display: none;

  @include local-mixins.desktop {
    width: 22.22%;
    display: initial;
  }

  @include local-mixins.tablet_and_mobile {
    @include filterFlyout;
  }

  @include local-mixins.tablet {
    @include filterFlyout;
  }

  & + .products-display {
    @include local-mixins.desktop {
      width: 71.11%;
    }

    :deep(.ais-Hits) {
      .ais-Hits-item {
        @include local-mixins.tablet {
          width: calc(33.33% - 1rem * 2 / 3);
        }

        @include local-mixins.desktop {
          width: calc(33.33% - 2rem * 2 / 3);
        }
      }
    }
  }

  :deep(.filter-accordion) {
    .wrapper {
      border-top: none;
      margin-bottom: 0;
    }
  }

  .filter-options {
    &:hover {
      cursor: initial;
    }
  }

  :deep(.filter-options) {
    .checkradio-container {
      margin-bottom: 1rem;
    }

    .checkradio-label {
      font-weight: normal;
    }
  }
}

.mobile-filter-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid $color-neutral-cool-200;
  padding-bottom: 1rem;

  .close-filter {
    width: 1.5rem;
    height: 1.5rem;
  }

  .close-svg {
    fill: $color-neutral-cool-900;
    margin-right: 0;
  }
}

.mobile-filter-title {
  font-size: #{local-functions.rem-calc(26)};
  font-weight: 500;
  line-height: 125%;
}

.mobile-filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: #{local-functions.rem-calc(22)};

  button {
    max-width: #{local-functions.rem-calc(350)};
    min-width: #{local-functions.rem-calc(105)};
    width: calc(50% - 0.5rem);
  }
}

.mobile-filter-header,
.mobile-filter-buttons {
  @include local-mixins.desktop {
    display: none;
  }
}

.results-page-title {
  text-transform: none;
  font-size: 30px;
  @include local-mixins.desktop {
    font-size: 38px;
  }
}

.ais-InstantSearch {
  margin-bottom: 2rem;
}

.ais-Stats {
  display: flex;
  justify-content: space-between;

  @include local-mixins.desktop {
    margin-bottom: 0.5rem;

    .mobile-filter-section {
      display: none;
    }
  }

  .mobile-filter-section {
    position: relative;
    margin-bottom: 0.5rem;
  }

  .mobile-filter-btn {
    max-width: #{local-functions.rem-calc(123)};
    justify-content: space-between;

    :deep(svg) {
      margin-right: 0;
    }
  }
}

.filter-clearing {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  min-height: #{local-functions.rem-calc(44)};
  padding: 0.5rem 0;
  overflow-x: auto;
  position: relative;

  @include local-mixins.desktop {
    margin-bottom: 1rem;
  }

  .clear-all-btn {
    flex-shrink: 0;
    font-size: 0.75rem;
    left: 0;
    line-height: 150%;
    position: sticky;
    text-decoration: underline;
    text-transform: none;
    width: #{local-functions.rem-calc(45)};
    z-index: map.get(local-vars.$zindex, 'page');

    @include local-mixins.desktop {
      position: initial;
      z-index: initial;
    }

    &:hover {
      cursor: pointer;
    }

    &:focus {
      box-shadow: none;
    }
  }

  .chip-wrapper {
    flex-shrink: 0;

    &.neutralgrey {
      color: $color-neutral-cool-900;

      &:deep() {
        .button-icon {
          background-color: $color-neutral-cool-900;
        }
      }
    }
  }
}

:deep(.ais-Hits) {
  .ais-Hits-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    @include local-mixins.tablet {
      gap: 1rem;
    }

    @include local-mixins.desktop {
      gap: 2rem;
    }
  }

  .ais-Hits-item {
    width: calc(50% - 1rem / 2);

    @include local-mixins.tablet {
      width: calc(25% - 1rem * 3 / 4);
    }

    @include local-mixins.desktop {
      width: calc(25% - 2rem * 3 / 4);
    }
  }
}

.product-title {
  font-size: 1rem;
  font-weight: 500;
  @include local-mixins.desktop {
    font-size: 1.25rem;
  }
}

.loading-container {
  @include local-mixins.desktop {
    display: flex;
    width: 100%;
    grid-gap: 2rem;
    gap: 2rem;
    .filter-section {
      width: 23%;
    }
    .items-container {
      width: -100%;
    }
  }
}
.items-container {
  grid-gap: 1rem;
  gap: 1rem;
  @include local-mixins.desktop {
    grid-gap: 2rem;
    gap: 2rem;
    width: 100%;
  }
}
.loading-item {
  width: calc(50% - 1rem / 2);
  .img {
    height: calc(50vw - 2rem);
  }
  @include local-mixins.tablet {
    width: calc(33% - 1rem * 3 / 4);
    .img {
      height: calc(33vw - 3rem);
    }
  }
  @include local-mixins.desktop {
    width: calc(33% - #{#{local-functions.rem-calc(32)}} * 3 / 4);
    .img {
      height: 320px;
    }
  }
}
</style>
